import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useHistory } from "react-router-dom";
import axios from 'axios';
import confetti from 'canvas-confetti';
import { useMediaQuery } from 'react-responsive';
import { 
	Typography, 
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogTitle, 
	DialogContent, 
	TextField 
} from '@material-ui/core';

import GreenButton from '../../customUI/GreenButton';
import DefaultInput from '../../customUI/DefaultInput';
import { storeContext } from '../provider/Provider';
import MobileTitle from '../../customUI/MobileTitle';
import BlueButton from '../../customUI/BlueButton';
import useStyles from './CallDetails.style';


const { REACT_APP_FLASK_API_URL } = process.env;

const CallDetailContainer = () => {
    const classes = useStyles();
    const { state } = useContext(storeContext);
    const location = useLocation();
    
    const [isLoading, setIsLoading] = useState(false);

    const history = useHistory();

    const [injured, setInjured] = useState('');
    const [personFault, setPersonFault] = useState('');
    const [whichQuestions, setWhichQuestions] = useState('');
    const [visitDoctor, setVisitDoctor] = useState('');
    const [haveInsurance, setHaveInsurance] = useState('');
    const [haveLawyer, setHaveLawyer] = useState('');
    const [propertyDamage, setProperyDamage] = useState('');
    
    const [summary, setSummary] = useState('');
    
    const [transcript, setTranscript] = useState('');
    
	const [openDialog, setOpenDialog] = useState(false);
	const [confirmationStep, setConfirmationStep] = useState(false);
	const [email, setEmail] = useState('');
  const [currentCallId, setCurrentCallId] = useState('');
  const [currentCallNumber, setCurrentCallNumber] = useState('');
	const [fullName, setFullName] = useState('');
	const [message, setMessage] = useState('');

    let isPhone = false;
    if (!state.websiteAnalytics.isTesting) {
        isPhone = useMediaQuery({ query: '(max-width: 768px)' });
    }

		const handleConvertCall = () => {
			const leadBody = {
				email,
				fullName,
				message,
				phone: currentCallNumber,
				website: state.websiteSwitch.currentWebsite,
			};
			axios
				.post(
					`${REACT_APP_FLASK_API_URL}/v1/calls/convert-to-lead/${state.websiteSwitch.currentWebsite}/${currentCallId}`,
					leadBody
				)
				.then((res) => {
					if (res.data.success) {
						setOpenDialog(false);
						setConfirmationStep(false);
						setEmail('');
						setFullName('');
						setMessage('');
						setCurrentCallNumber('');
						setCurrentCallId('');
						confetti({
							particleCount: 200,
							angle: 40,
							spread: 100,
							origin: { x: 0 },
							zIndex: 1200,
							colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
						});
						confetti({
							particleCount: 200,
							angle: 140,
							spread: 100,
							origin: { x: 1 },
							zIndex: 1200,
							colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
						});
						history.push({
							pathname: `/opportunities/`
						});
					}
				});
		};
   
    useEffect(() => {
        setIsLoading(true);
        axios.get(`${REACT_APP_FLASK_API_URL}/v1/get-call-metrics/${state.websiteSwitch.currentWebsite}/${location.state.detail.id}/transcription`).then((res) => {
            setInjured(res.data.message.questions['Was the person injured?']);
            setPersonFault(res.data.message.questions['Was the person at fault?']);
            setVisitDoctor(res.data.message.questions['Have customer visited a doctor?']);
			  setWhichQuestions(res.data.message.questions['Which questions did the person asked during the call?']);
            setHaveInsurance(res.data.message.questions['Do both parties have insurance?'])
            setHaveLawyer(res.data.message.questions['Do customer already have a lawyer?'])
            setProperyDamage(res.data.message.questions['Was there property damage only?'])
            setSummary(res.data.message.summary)
            setTranscript(res.data.message.full)
            setIsLoading(false)
        }).catch(() => {
            setIsLoading(false);
        })
    }, []);
		
		const handleBackClick = () => {
      history.push({
        pathname: `/opportunities/`,
		state: { source: 'calls' }
    	});
    }
    return (
        <>
        {isLoading ?
        <>
          <div className={classes.loading} style={{ height: 400 }}>
            <CircularProgress />
          </div></> : <>
        
            {
                isPhone ? <MobileTitle title="Call Detail" /> : <></>
            }
            <div className={isPhone ? '' : classes.wrapper} style={{ background: 'none', margin: '0 10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' , justifyContent: 'flex-start', alignItems: 'flex-start', paddingBottom: '20px' }}>
                    <Typography className={classes.heading} style={{ color: '#00b4e0', cursor: 'pointer', margin: '0', paddingRight: '5px', paddingLeft: '0px', fontSize: 17, display: 'none' }} onClick={handleBackClick}>&laquo; Opportunities</Typography>
										<Typography className={classes.heading} style={{ margin: '0', paddingLeft: '0', paddingTop: '5px' }} >Call from: <Box component="a" style={{ color: '#00b4e0', textDecoration: 'none'}} href={`tel:${location.state.detail.caller_number_complete}`}>{location.state.detail.caller_number_complete}</Box></Typography>
                </div>
                <div className={classes.formContainer} style={{ margin: '0'}}>
                    <div className={classes.innerBoxContainer} style={{ 
							flexDirection: 'row', 
							alignItems: 'center', 
							paddingTop: 5,
							paddingBottom: 5,
						}}>
                        {/* Date */}
                        <div className={classes.formInputsContainer} style={{ paddingTop: 0 }}>
                            <Box className={classes.TextIconContainer} style={{ flexDirection: isPhone ? 'column' : 'row', alignItems: isPhone ? 'flex-start' : 'center'}}>
                                <Typography variant='body1' className={classes.textTitleStyle}>Date: </Typography>
                                <Typography variannt='body1' className={classes.textStyle}>{
                                    new Date(location.state.detail.called_at).toLocaleDateString('en-us', {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric',
                                      })
                                }</Typography>
                            </Box>
                        </div>
                        {/* Duration */}
                        <div className={classes.formInputsContainer} style={{ paddingTop: 0 }}>
                            <Box className={classes.TextIconContainer} style={{ flexDirection: isPhone ? 'column' : 'row', alignItems: isPhone ? 'flex-start' : 'center'}}>
                                <Typography variant='body1' className={classes.textTitleStyle}>Call Duration: </Typography>
                                <Typography variant='body1' className={classes.textStyle}>{new Date(location.state.detail.duration * 1000).toISOString().substr(11, 8)}</Typography>
                            </Box>
                        </div>
                        {/* Source */}
                        <div className={classes.formInputsContainer} style={{ paddingTop: 0 }}>
                            <Box className={classes.TextIconContainer} style={{ flexDirection: isPhone ? 'column' : 'row', alignItems: isPhone ? 'flex-start' : 'center'}}>
                                <Typography variant='body1' className={classes.textTitleStyle}>Source: </Typography>
                                <Typography variannt='body1' className={classes.textStyle}>{location.state.detail.source}</Typography>
                            </Box>
                        </div>
												<div style={{ marginLeft: 'auto', marginRight: '10px'}}>
												<BlueButton
													aria-label="convert call to lead"
													onClick={() => {
															setCurrentCallNumber(location.state.detail.caller_number_complete);
															setCurrentCallId(location.state.detail.id);
															setOpenDialog(true);
													}}
													style={{
														whiteSpace: 'nowrap'  
													}}
											>
													Add Lead
											</BlueButton>
												</div>
                    </div>
                    <div className={classes.innerBoxContainer}>
                        {/* Summary */}
                        <div className={classes.formInputsContainer}>
														<Typography variant='body1' className={classes.titleOutside}>Summary</Typography>
                            <Box className={classes.TextIconContainer}>
                                <Typography variannt='body1' className={classes.insideTextBold}>{summary}</Typography>
                            </Box>
                        </div>
                    </div>
                    <div className={classes.innerBoxContainer}>
                        {/* Questions */}
                        <div className={classes.formInputsContainer}>
							<Typography variant='body1' className={classes.titleOutside}>Detailed Questions</Typography>
							<Typography variant='body1' className={classes.textTitleStyle}>Which questions did the person asked during the call?</Typography>
                            <Box className={classes.TextIconContainer}>
                                <ul className={classes.unorderListContainer}>
                                    <li style={{}} className={classes.listContainer}>
                                        {whichQuestions}
                                    </li>
                                </ul>
                            </Box>
                        </div>
                        {/* Injured */}
                        <div className={classes.formInputsContainer}>
							<Typography variant='body1' className={classes.textTitleStyle}>Was the person injured? </Typography>
							<Box className={classes.TextIconContainer}>
								<ul className={classes.unorderListContainer}>
									<li style={{}} className={classes.listContainer}>
										{injured}
									</li>
								</ul>
							</Box>
                        </div>
						{/* Fault */}
                        <div className={classes.formInputsContainer}>
                            <Typography variant='body1' className={classes.textTitleStyle}>Was the person at fault? </Typography>
                            <Box className={classes.TextIconContainer}>
                                <ul className={classes.unorderListContainer}>
                                    <li style={{}} className={classes.listContainer}>
                                        {personFault}
                                    </li>
                                </ul>
                            </Box>
                        </div>
                        {/* Insurance */}
                        <div className={classes.formInputsContainer}>
                            <Typography variant='body1' className={classes.textTitleStyle}>Do both parties have insurance? </Typography>
                            <Box className={classes.TextIconContainer}>
                                <ul className={classes.unorderListContainer}>
                                    <li style={{}} className={classes.listContainer}>
                                        {haveInsurance}
                                    </li>
                                </ul>
                            </Box>
                        </div>
                        {/* Doctor */}
                        <div className={classes.formInputsContainer}>
                            <Typography variant='body1' className={classes.textTitleStyle}>Have you visited a doctor?</Typography>
                            <Box className={classes.TextIconContainer}>
                                <ul className={classes.unorderListContainer}>
                                    <li style={{}} className={classes.listContainer}>
                                        {visitDoctor}
                                    </li>
                                </ul>
                            </Box>
                        </div>
                        {/* Lawyer */}
                        <div className={classes.formInputsContainer}>
                            <Typography variant='body1' className={classes.textTitleStyle}>Do you have already a lawyer?</Typography>
                            <Box className={classes.TextIconContainer}>
                                <ul className={classes.unorderListContainer}>
                                    <li style={{}} className={classes.listContainer}>
                                        {haveLawyer}
                                    </li>
                                </ul>
                            </Box>
                        </div>
                        {/* Only property */}
                        <div className={classes.formInputsContainer}>
                            <Typography variant='body1' className={classes.textTitleStyle}>Was there property damage only?</Typography>
                            <ul className={classes.unorderListContainer}>
                                <li style={{}} className={classes.listContainer}>
                                    {propertyDamage}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className={classes.innerBoxContainer}>
                        <div className={classes.formInputsContainer}>
													<Typography variant='body1' className={classes.titleOutside}>Transcript</Typography>
												  <Box className={classes.TextIconContainer}>
														<Typography variannt='body1' className={classes.insideTextBold} style={{ whiteSpace: 'pre-wrap' }}>{transcript}</Typography>
													</Box>
                        </div>
                    </div>
                </div>
            </div>
						<Dialog
							open={openDialog}
							onClose={() => {
								setOpenDialog(false);
								setFullName('');
								setMessage('');
								setCurrentCallNumber('');
								setConfirmationStep(false);
							}}
						>
							<DialogTitle>Convert {currentCallNumber} Call to Lead</DialogTitle>
							<DialogContent>
							{!confirmationStep && <Box textAlign='left'>Are you sure you want to add this opportunity to Leads?</Box>}
							{confirmationStep && <Box fontWeight='bold' py={2} textAlign='left'>Please review lead data before continue this action cannot be reverted</Box>}
								<Box display={confirmationStep ? 'none' : 'block'}>
									<TextField
										margin="dense"
										id="full name"
										label="Contact's Full Name *"
										fullWidth
										value={fullName}
										onChange={(e) => {
											setFullName(e.target.value);
										}}
									/>
									<TextField
										margin="dense"
										id="full name"
										label="Contact's Email *"
										fullWidth
										value={email}
										onChange={(e) => {
											setEmail(e.target.value);
										}}
									/>
									<DefaultInput
										style={{ marginTop: 10, width: '100%' }}
										rows={5}
										multiline
										label="Message"
										value={message}
										data-testid="details_test_id"
										type="text"
										onChange={(e) => {
											setMessage(e.target.value);
										}}
									/>
								</Box>
								<Box display={confirmationStep ? 'block' : 'none'}>
									<Box>
										<Box fontWeight='bold' pt={1} pr={1} display='inline-block' style={{ textTransform: 'capitalize' }}>Email: </Box>
										<span>
											{email}
										</span>
									</Box>
									<Box>
										<Box fontWeight='bold' pt={1} pr={1} display='inline-block' style={{ textTransform: 'capitalize' }}>Full Name: </Box>
										<span>
											{fullName}
										</span>
									</Box>
									<Box>
										<Box fontWeight='bold' pt={1} pr={1} display='inline-block' style={{ textTransform: 'capitalize' }}>Message: </Box>
										<span>
											{message}
										</span>
									</Box>
								</Box>
							</DialogContent>
							<DialogActions>
							<Box display={confirmationStep ? 'none' : 'block'}>
									<Button
										onClick={() => {
											setOpenDialog(false);
											setFullName('');
											setMessage('');
											setEmail('');
											setCurrentCallNumber('');
											setConfirmationStep(false);
										}}
										style={{ color: '#58595B' }}
									>
										Cancel
									</Button>
									<GreenButton aria-label="submit convert" onClick={() => {
											setConfirmationStep(true)
										}} >
										Review
									</GreenButton>
								</Box>
								<Box display={confirmationStep ? 'block' : 'none'}>
									<Button
										onClick={() => {
											setConfirmationStep(false);
										}}
										style={{ color: '#58595B' }}
									>
										Back
									</Button>
									<GreenButton aria-label="submit convert" onClick={handleConvertCall}>
										Submit
									</GreenButton>
								</Box>
							</DialogActions>
						</Dialog>
            </> }
        </>
    );
};

export default CallDetailContainer;
